// should be disabled AR
// should be hide promo code
export const TMobilePromoCodes = ['YOU']; // should be disabled AR
// should be hide promo code
export const TMRShellPromoCodes = ['SHELLBY', 'MRSHELL'];
